// extracted by mini-css-extract-plugin
export default {"ambientalL3":"AmbientalL3_ambientalL3__n7UMJ","pieGraph":"AmbientalL3_pieGraph__CwTXM","graph":"AmbientalL3_graph__aWCP8"};